import {
  CREATE_BENEFIT,
  CREATE_BENEFIT_FAILURE,
  CREATE_BENEFIT_SUCCESS,
  DELETE_BENEFIT,
  DELETE_BENEFIT_FAILURE,
  DELETE_BENEFIT_SUCCESS,
  DELETE_BENEFITS,
  DELETE_BENEFITS_FAILURE,
  DELETE_BENEFITS_SUCCESS,
  FETCH_BENEFITS,
  FETCH_BENEFITS_FAILURE,
  FETCH_BENEFITS_SUCCESS,
  GET_BENEFIT,
  GET_BENEFIT_FAILURE,
  GET_BENEFIT_SUCCESS,
  GET_BENEFIT_VALUES,
  GET_BENEFIT_VALUES_FAILURE,
  GET_BENEFIT_VALUES_SUCCESS,
  RESET_BENEFIT,
  UPDATE_BENEFIT,
  UPDATE_BENEFIT_FAILURE,
  UPDATE_BENEFIT_SUCCESS,
} from "./actionTypes";

// Fetch Benefits
export const fetchBenefits = (params) => ({
  type: FETCH_BENEFITS,
  payload: params,
});

export const fetchBenefitsSuccess = (accounts) => ({
  type: FETCH_BENEFITS_SUCCESS,
  payload: accounts,
});

export const fetchBenefitsFailure = (error) => ({
  type: FETCH_BENEFITS_FAILURE,
  payload: error,
});

// Create Benefits
export const createBenefit = (benefitRequest) => ({
  type: CREATE_BENEFIT,
  payload: benefitRequest,
});

export const createBenefitSuccess = (benefit) => ({
  type: CREATE_BENEFIT_SUCCESS,
  payload: benefit,
});

export const createBenefitFailure = (error) => ({
  type: CREATE_BENEFIT_FAILURE,
  payload: error,
});

// Delete Benefits
export const deleteBenefit = (id) => ({
  type: DELETE_BENEFIT,
  payload: id,
});

export const deleteBenefitSuccess = (response) => ({
  type: DELETE_BENEFIT_SUCCESS,
  payload: response,
});

export const deleteBenefitFailure = (error) => ({
  type: DELETE_BENEFIT_FAILURE,
  payload: error,
});

// Delete Benefits
export const deleteBenefits = (ids) => ({
  type: DELETE_BENEFITS,
  payload: ids,
});

export const deleteBenefitsSuccess = (response) => ({
  type: DELETE_BENEFITS_SUCCESS,
  payload: response,
});

export const deleteBenefitsFailure = (error) => ({
  type: DELETE_BENEFITS_FAILURE,
  payload: error,
});

// Update Benefits
export const updateBenefit = (benefitRequest) => ({
  type: UPDATE_BENEFIT,
  payload: benefitRequest,
});

export const updateBenefitSuccess = (benefit) => ({
  type: UPDATE_BENEFIT_SUCCESS,
  payload: benefit,
});

export const updateBenefitFailure = (error) => ({
  type: UPDATE_BENEFIT_FAILURE,
  payload: error,
});

// Get benefit
export const getBenefit = (id) => ({
  type: GET_BENEFIT,
  payload: id,
});

export const getBenefitSuccess = (benefit) => ({
  type: GET_BENEFIT_SUCCESS,
  payload: benefit,
});

export const getBenefitFailure = (error) => ({
  type: GET_BENEFIT_FAILURE,
  payload: error,
});

export const getBenefitValues = (request) => ({
  type: GET_BENEFIT_VALUES,
  payload: request,
});

export const getBenefitValueSuccess = (benefit) => ({
  type: GET_BENEFIT_VALUES_SUCCESS,
  payload: benefit,
});

export const getBenefitValueFailure = (error) => ({
  type: GET_BENEFIT_VALUES_FAILURE,
  payload: error,
});

export const resetBenefit = () => ({
  type: RESET_BENEFIT,
});
